import { DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI } from '../../../types/default-cloud-graph-document-entity-ati';
import { type ThirdPartyConfig } from '../../../types/schemas/types';
import { NounSubtypeKey, TypeFilterValueKey } from '../../../utils/filters/universalType';
import { get3PLogo } from '../../icons';
import { ProductResourceTypes3P } from '../types';
import { OneDriveIcon, OneDriveIconBorderless, OneDriveSearchResultIcon } from './icon';

export const oneDriveConfig: ThirdPartyConfig = {
	displayName: 'OneDrive',
	id: 'onedrive',
	resourceType: ProductResourceTypes3P.OneDrive,
	icon: get3PLogo(OneDriveIcon, 'OneDrive', 'medium'),
	iconBorderless: get3PLogo(OneDriveIconBorderless, 'OneDrive', 'small'),
	searchResultIcon: get3PLogo(OneDriveSearchResultIcon, 'OneDrive', 'large'),
	integrationAri: 'ari:cloud:platform::integration/microsoft',
	typeFilterConfig: new Map([
		[
			TypeFilterValueKey.Document,
			{
				entities3P: DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI,
				subTypes3P: [NounSubtypeKey.Document, NounSubtypeKey.Pdf],
			},
		],
		[
			TypeFilterValueKey.Spreadsheet,
			{
				entities3P: DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI,
				subTypes3P: [NounSubtypeKey.Spreadsheet],
			},
		],
		[
			TypeFilterValueKey.Presentation,
			{
				entities3P: DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI,
				subTypes3P: [NounSubtypeKey.Presentation],
			},
		],
	]),
	filters: ['lastUpdated', 'onlyTitleMatch'],
	requiresOauth: true,
	isEnabled: () => true,
};
